"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _function = require("../../utils/function");
var _CircleTitleModule = _interopRequireDefault(require("../../styles/components/Circles/CircleTitle.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const CircleTitle = _ref => {
  var _useSelector;
  let {
    displayNameId,
    hover = false,
    title = '',
    isPositionValue = false
  } = _ref;
  const timeout = (0, _react.useRef)(null);
  const [showTicker, setShowTicker] = (0, _react.useState)(false);
  const [playTicker, setPlayTicker] = (0, _react.useState)(false);
  const tV = ((_useSelector = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsValues)) === null || _useSelector === void 0 ? void 0 : _useSelector.Default) || {};
  const text = (0, _react.useMemo)(() => title || (isPositionValue ? (0, _function.getPositionText)({
    displayNameId,
    tVDefault: tV
  }) : ''), [displayNameId, tV, title, isPositionValue]);
  const checkOnShowTicker = (0, _react.useCallback)(function () {
    let el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return _paulCorePackage.functions.textIsPlacedInBlock(el);
  }, []);
  (0, _react.useEffect)(() => {
    const title = document.querySelector("#position_value_".concat(displayNameId));
    if (title) setShowTicker(checkOnShowTicker(title));
  }, [displayNameId, text]);
  (0, _react.useEffect)(() => {
    if (showTicker) {
      if (timeout.current) clearTimeout(timeout.current);
      if (hover) {
        setPlayTicker(true);
      } else {
        timeout.current = setTimeout(() => setPlayTicker(false), 500);
      }
    }
  }, [hover, showTicker]);
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: _CircleTitleModule.default.name_box
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(_CircleTitleModule.default.text, " ").concat(showTicker && playTicker ? _CircleTitleModule.default.marquee : '', " ").concat(showTicker && !playTicker ? _CircleTitleModule.default.short : '')
  }, /*#__PURE__*/_react.default.createElement("span", null, text || '--')), /*#__PURE__*/_react.default.createElement("span", {
    id: "position_value_".concat(displayNameId),
    className: _CircleTitleModule.default.hidden
  }, text)), [text, showTicker, displayNameId, playTicker]);
};
var _default = exports.default = CircleTitle;